import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../style/style.css";

const NAV_ITEMS = [
    { label: "Home", target: "home" },
    { label: "Skill", target: "my-skill" },
    { label: "Degree", target: "study" },
    { label: "Work & Experience", target: "work" },
];

const PageHeader = (props) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeTarget, setActiveTarget] = useState("home");

    // Subtle shadow/border once the page scrolls past the hero.
    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // Highlight whichever section is currently in view.
    useEffect(() => {
        const sections = NAV_ITEMS.map((item) =>
            document.getElementById(item.target)
        ).filter(Boolean);

        if (sections.length === 0) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const visible = entries
                    .filter((entry) => entry.isIntersecting)
                    .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
                if (visible) setActiveTarget(visible.target.id);
            },
            { rootMargin: "-40% 0px -55% 0px", threshold: [0, 0.25, 0.5, 0.75, 1] }
        );

        sections.forEach((section) => observer.observe(section));
        return () => observer.disconnect();
    }, []);

    const toggleOffcanvas = () => {
        const offcanvasElement = document.getElementById("mobile-menu");
        offcanvasElement.classList.toggle("show");
        document.body.classList.toggle("no-scroll");
    };

    const closeOffcanvas = () => {
        const offcanvasElement = document.getElementById("mobile-menu");
        offcanvasElement.classList.remove("show");
        document.body.classList.remove("no-scroll");
    };

    const goTo = (targetId) => {
        if (targetId === "home") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
        }
        closeOffcanvas();
    };

    const contact = () => {
        document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
        closeOffcanvas();
    };

    return (
        <>
            <header>
                <div className={`page-header${isScrolled ? " is-scrolled" : ""}`}>
                    <div className="logo">
                        <span className="logo-mark">V</span>
                        <span className="logo-name">Verak</span>
                    </div>

                    <nav className="page-menu">
                        <ul>
                            {NAV_ITEMS.map((item) => (
                                <li key={item.target}>
                                    <Link
                                        to="/"
                                        onClick={() => goTo(item.target)}
                                        className={activeTarget === item.target ? "is-active" : ""}
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                            {props.children}
                        </ul>
                    </nav>

                    <button
                        type="button"
                        className="mobile-toggle"
                        onClick={toggleOffcanvas}
                        aria-label="Open menu"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="currentColor"
                        >
                            <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
                        </svg>
                    </button>

                    <div className="rl-user">
                        <button onClick={contact} className="btn-contact">
                            Contact Me
                        </button>
                    </div>
                </div>
            </header>

            <div
                className="offcanvas offcanvas-start"
                data-bs-backdrop="static"
                tabIndex="-1"
                id="mobile-menu"
                aria-labelledby="mobile-menu-label"
            >
                <div className="offcanvas-header">
                    <span id="mobile-menu-label" className="offcanvas-title">
                        Menu
                    </span>
                    <button
                        type="button"
                        className="offcanvas-close"
                        onClick={closeOffcanvas}
                        aria-label="Close menu"
                    >
                        ×
                    </button>
                </div>
                <div className="offcanvas-body">
                    <ul>
                        {NAV_ITEMS.map((item) => (
                            <li key={item.target}>
                                <Link
                                    to="/"
                                    onClick={() => goTo(item.target)}
                                    className={activeTarget === item.target ? "is-active" : ""}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <Link to="/" onClick={contact}>
                                Contact Me
                            </Link>
                        </li>
                        {props.children}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default PageHeader;